<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Accessories</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        <div class="configurationDetailRow">
          @if (ballValveSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Ball Valve:</label>
              <select class="halfWidthInputField" #ballValveInput
                [class.invalidConfigurationSelection]="isInvalidSelection(ballValveSelection.Name)"
                (change)="selectionChanged(ballValveSelection, ballValveInput.value)"
                [value]="ballValveSelection.Value.toString()">
                @for (allowable of ballValveSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="ballValveSelection.Value && ballValveSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (doasSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">DOAS:</label>
              <select class="halfWidthInputField" #doasInput
                [class.invalidConfigurationSelection]="isInvalidSelection(doasSelection.Name)"
                (change)="selectionChanged(doasSelection, doasInput.value)"
                [value]="doasSelection.Value.toString()">
                @for (allowable of doasSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="doasSelection.Value && doasSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (hoseKitSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Hose Kits:</label>
              <select class="halfWidthInputField" #hoseKitsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(hoseKitSelection.Name)"
                (change)="selectionChanged(hoseKitSelection, hoseKitsInput.value)"
                [value]="hoseKitSelection.Value.toString()">
                @for (allowable of hoseKitSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="hoseKitSelection.Value && hoseKitSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (filterSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Replacement Filter:</label>
              <select class="halfWidthInputField" #filterInput
                [class.invalidConfigurationSelection]="isInvalidSelection(filterSelection.Name)"
                (change)="selectionChanged(filterSelection, filterInput.value)"
                [value]="filterSelection.Value.toString()">
                @for (allowable of filterSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="filterSelection.Value && filterSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (roofCurbSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Roofcurb:</label>
              <select class="halfWidthInputField" #roofCurbInput
                [class.invalidConfigurationSelection]="isInvalidSelection(roofCurbSelection.Name)"
                (change)="selectionChanged(roofCurbSelection, roofCurbInput.value)"
                [value]="roofCurbSelection.Value.toString()">
                @for (allowable of roofCurbSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="roofCurbSelection.Value && roofCurbSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (thermostatSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Thermostat:</label>
              <select class="halfWidthInputField" #thermostatInput
                [class.invalidConfigurationSelection]="isInvalidSelection(thermostatSelection.Name)"
                (change)="selectionChanged(thermostatSelection, thermostatInput.value)"
                [value]="thermostatSelection.Value.toString()">
                @for (allowable of thermostatSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="thermostatSelection.Value && thermostatSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (controlsSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Controls:</label>
              <select class="halfWidthInputField" #controlsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(controlsSelection.Name)"
                (change)="selectionChanged(controlsSelection, controlsInput.value)"
                [value]="controlsSelection.Value.toString()">
                @for (allowable of controlsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="controlsSelection.Value && controlsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (drainPanSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Drain Pan:</label>
              <select class="halfWidthInputField" #drainPanInput
                [class.invalidConfigurationSelection]="isInvalidSelection(drainPanSelection.Name)"
                (change)="selectionChanged(drainPanSelection, drainPanInput.value)"
                [value]="drainPanSelection.Value.toString()">
                @for (allowable of drainPanSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="drainPanSelection.Value && drainPanSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (waterValveSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Water Valve:</label>
              <select class="halfWidthInputField" #waterValveInput
                [class.invalidConfigurationSelection]="isInvalidSelection(waterValveSelection.Name)"
                (change)="selectionChanged(waterValveSelection, waterValveInput.value)"
                [value]="waterValveSelection.Value.toString()">
                @for (allowable of waterValveSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="waterValveSelection.Value && waterValveSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
      </div>
    </div>
  }
</div>
